import { render, staticRenderFns } from "./DialogHeader.vue?vue&type=template&id=7f2f8c28&scoped=true&"
import script from "./DialogHeader.vue?vue&type=script&lang=js&"
export * from "./DialogHeader.vue?vue&type=script&lang=js&"
import style0 from "./DialogHeader.vue?vue&type=style&index=0&id=7f2f8c28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2f8c28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f2f8c28')) {
      api.createRecord('7f2f8c28', component.options)
    } else {
      api.reload('7f2f8c28', component.options)
    }
    module.hot.accept("./DialogHeader.vue?vue&type=template&id=7f2f8c28&scoped=true&", function () {
      api.rerender('7f2f8c28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/dialog/DialogHeader.vue"
export default component.exports